import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import { useGetIntegrations } from "@src/api/integrations/get-integrations";
import { SetupGoogleIntegration } from "@src/components/Google/SetupGoogleIntegration";
import { IntegrationView } from "@src/domains/Settings/Integrations/IntegrationView";
import Loading from "@src/utils/Loading";

import { AmpedIntegration } from "./Amped/AmpedIntegration";
import { RechargeIntegration } from "./Recharge/RechargeIntegration";
import { StayAiIntegration } from "./StayAi/StayAiIntegration";

const Title = ({ title }: { title: string }) => {
  return (
    <Grid item>
      <IgTypography variant={"h2"} sx={{ fontWeight: 600 }}>
        {title}
      </IgTypography>
    </Grid>
  );
};

export const IntegrationsRoute = () => {
  const integrations = useGetIntegrations();

  if (integrations.isSuccess) {
    const map = new Map(
      integrations.data?.integrations.map((i) => [i.name, i])
    );
    return (
      <Grid container direction={"column"} rowSpacing={5}>
        <Grid item xs>
          <IgTypography fontWeight={"fontWeightMedium"} variant={"h1"}>
            Third-Party Integrations
          </IgTypography>
        </Grid>
        <Title title={"Analytics"} />
        <Grid item>
          <SetupGoogleIntegration googleIntegration={map.get("Google")} />
        </Grid>
        <IntegrationView name={"Clarity"} config={map.get("Clarity")} />
        <IntegrationView name={"Heatmap"} config={map.get("Heatmap")} />
        <IntegrationView name={"Hotjar"} config={map.get("Hotjar")} />
        <IntegrationView name={"Amplitude"} config={map.get("Amplitude")} />
        <IntegrationView name={"Heap"} config={map.get("Heap")} />
        <IntegrationView name={"Segment"} config={map.get("Segment")} />
        <Title title={"Subscription Apps"} />
        <Grid item>
          <RechargeIntegration rechargeIntegration={map.get("Recharge")} />
        </Grid>
        <Grid item>
          <StayAiIntegration stayAiIntegration={map.get("StayAi")} />
        </Grid>
        <Title title={"On-site Apps"} />
        <Grid item>
          <AmpedIntegration ampedIntegration={map.get("Amped")} />
        </Grid>
      </Grid>
    );
  }
  return <Loading />;
};
